import styled from 'styled-components';

export const SearchBoxStyled = styled.div`
  margin: 0 8px 0 0;

  [class*='StyledSelect'] {
    min-width: 316px;
  }
`;
